import messages from "./english.json";

const resolveMessage = (key) =>
  String(key)
    .split(".")
    .reduce((value, part) => value?.[part], messages);

export const t = (key, options) => {
  const config = typeof options === "string" ? { defaultValue: options } : options || {};
  const value = resolveMessage(key);

  if (config.returnObjects && value !== undefined) return value;
  if (typeof value !== "string") return config.defaultValue ?? String(key);

  return value.replace(/{{\s*([\w.-]+)\s*}}/g, (placeholder, name) => {
    const replacement = config[name];
    return replacement === undefined || replacement === null
      ? placeholder
      : String(replacement);
  });
};

export function useEnglishText() {
  return { t };
}
